import { H5, H6 } from "@sellar-io/components";
import { SupplierGetResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { twMerge } from "tailwind-merge";
import { ProfilePicture } from "../../../../../../components";
import {
  ProfilePictureCollection,
  ProfilePictureCollectionImage,
} from "../../../../../../components/profilePictureCollection/profilePictureCollection";
export const StorefrontSignupDialogSupplierInfo = ({
  supplier,
  className,
}: {
  supplier?: SupplierGetResponseType;
  className?: string;
}): ReactElement => {
  return (
    <div
      className={twMerge("col-span-6 flex flex-col items-center", className)}
    >
      <div
        className={twMerge(
          "flex flex-col items-center justify-center lg:m-auto",
        )}
      >
        <ProfilePicture
          logoUrl={supplier?.Business.logoUrl}
          size={"large"}
          className={"m-auto"}
        />
        <H5>{supplier?.Business.name}</H5>
        <H6>
          {supplier?.Business.DeliveryAddress.city}
          {supplier?.Business.DeliveryAddress.region
            ? `, ${supplier.Business.DeliveryAddress.region}`
            : ""}
        </H6>
        <ProfilePictureCollection className="mt-4 flex flex-row">
          {supplier?.supplierProfileDetails.map((user, index) => (
            <ProfilePictureCollectionImage
              key={index}
              imageUrl={user.profileImageUrl}
              name={user.name}
            />
          ))}
        </ProfilePictureCollection>
      </div>
    </div>
  );
};
